import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-filters-bar',
  templateUrl: './filters-bar.component.html',
  styleUrls: ['./filters-bar.component.css'],
})
export class FiltersBarComponent implements OnInit {
  @Input() statusOptions: string[] = [];
  @Input() orderByOptions: string[] = [];

  @Output() filtersChanged = new EventEmitter<{
    name?: string;
    status?: string[];
    dateRange?: [Date, Date];
    orderBy?: string;
  }>();

  filtersForm!: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.filtersForm = this.fb.group({
      name: [''],
      status: [[]],
      dateRange: this.fb.group({
        start: [null],
        end: [null],
      }),
      orderBy: [null],
    });
  }

  /**
   * Emits the current filter values.
   */
  applyFilters(): void {
    const filters = this.mapFilters(this.filtersForm.value);
    this.filtersChanged.emit(filters);
  }

  /**
   * Resets the form to its default state.
   */
  resetFilters(): void {
    this.filtersForm.reset({
      name: '',
      status: [],
      dateRange: { start: null, end: null },
      orderBy: null,
    });
    this.applyFilters(); // Emit empty state after resetting
  }

  private mapFilters(filters: any): {
    name?: string;
    status?: string[];
    dateRange?: [Date, Date];
    orderBy?: string;
  } {
    const dateRange = filters.dateRange;
    return {
      name: filters.name?.trim() || undefined,
      status: filters.status?.length ? filters.status : undefined,
      dateRange: dateRange.start && dateRange.end ? [dateRange.start, dateRange.end] : undefined,
      orderBy: filters.orderBy || undefined,
    };
  }
}
